export const DOMAIN_PLACE_KIND = {
	WORKING: 'working',
	INTERNAL: 'internal',
	PROJECT: 'project',
	UNRESOLVED: 'unresolved',
} as const;

export type DomainPlaceKind = (typeof DOMAIN_PLACE_KIND)[keyof typeof DOMAIN_PLACE_KIND];
